import type { Components, Theme } from "@mui/material/styles";

import { TAB_INDICATOR_SPACING } from "./tab";

export const MuiTabs: Components<Theme>["MuiTabs"] = {
  defaultProps: {
    color: "primary",
  },
  styleOverrides: {
    root: ({ theme }) => ({
      marginBottom: theme.spacing(-TAB_INDICATOR_SPACING),
      minHeight: theme.spacing(5),
    }),
    indicator: ({ theme }) => ({
      backgroundColor: theme.palette.primary.main,
      bottom: theme.spacing(TAB_INDICATOR_SPACING),
      height: theme.spacing(TAB_INDICATOR_SPACING),
      "&::after": {
        border: `${theme.spacing(TAB_INDICATOR_SPACING)} solid transparent`,
        borderTop: `${theme.spacing(TAB_INDICATOR_SPACING)} solid ${
          theme.palette.primary.main
        }`,
        content: '""',
        display: "block",
        position: "absolute",
        height: 0,
        width: 0,
        top: theme.spacing(TAB_INDICATOR_SPACING),
        left: "50%",
        transform: `translateX(-50%)`,
      },

      variants: Object.entries(theme.palette)
        .filter(([_, values]) => typeof values === "object" && "main" in values)
        .map(([color, values]) => ({
          props: {
            color,
          },
          style: {
            backgroundColor: values.main,

            "&::after": {
              borderTopColor: values.main,
            },
          },
        })),
    }),

    /**
     * the indicator defaults to left: 0 if no tab is selected
     * that leaves half of the indicator notch visible
     * by adding padding, left: 0 is moved beyond the extent of the left-most tab
     * by adding negative margin, we reset the tabs at the original starting point
     */
    scroller: ({ theme }) => ({
      margin: theme.spacing(0, -TAB_INDICATOR_SPACING),
      overflowY: "clip",
      padding: 0,
      zIndex: 1000,
    }),
  },
};
